import { Skeleton, Typography } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import * as React from 'react';
import { Link as LinkRouter, useParams } from 'react-router-dom';
import { useDisbursement } from '../../../api/DisbursementsApi';
import {
	UI_CASH_MANAGEMENT_FEATURE_ENABLED,
	useAuthContext,
} from '../../../context/auth';
import {
	DISBURSEMENTS_BREADCRUMB__EDIT,
	DISBURSEMENTS_BREADCRUMB__NEW,
	DISBURSEMENTS_PAGE_TITLE,
	DISBURSEMENT_PAGE__TITLE,
} from '../data/constants';

interface ActiveLastBreadcrumbProps {
	loading?: boolean;
	isEdit?: boolean;
	isNew?: boolean;
}

export default function ActiveLastBreadcrumb(props: ActiveLastBreadcrumbProps) {
	const { loading, isEdit, isNew } = props;
	const params = useParams();
	const authData = useAuthContext();
	const authToken = authData.auth?.authorizationToken;
	const { disbursementLocator } = params;
	const cashManagementEnabled =
		authData?.auth?.configProperties?.[UI_CASH_MANAGEMENT_FEATURE_ENABLED];

	const { data: disbursement } = useDisbursement(
		disbursementLocator,
		authToken,
		cashManagementEnabled,
		authData?.hasPermission('disbursement.fetch'),
	);

	return loading ? (
		<Breadcrumbs aria-label='breadcrumb'>
			<Skeleton variant='text' width={300} />
		</Breadcrumbs>
	) : (
		<Breadcrumbs aria-label='breadcrumb'>
			<Link
				component={LinkRouter}
				underline='hover'
				color='inherit'
				to='/disbursements'
			>
				{DISBURSEMENTS_PAGE_TITLE}
			</Link>
			{disbursement && (
				<Link
					component={LinkRouter}
					underline='hover'
					color='inherit'
					to={`/disbursements/${disbursement}`}
					aria-current='page'
				>
					{DISBURSEMENT_PAGE__TITLE + ' ' + disbursement.locator}
				</Link>
			)}
			{isEdit && (
				<Typography color='inherit'>
					{DISBURSEMENTS_BREADCRUMB__EDIT}
				</Typography>
			)}
			{isNew && (
				<Typography color='inherit'>{DISBURSEMENTS_BREADCRUMB__NEW}</Typography>
			)}
		</Breadcrumbs>
	);
}
